export default __webpack_public_path__ + "static/media/ungabg.9779a920.jpg";